import React from "react";
import { MapPin, Calendar, Briefcase, Award } from "lucide-react";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_derya-stock-picks/artifacts/yfe37zr4_SnapInsta.to_497327459_18499252195058180_803585894726712750_n.jpg";

const META = [
  { icon: MapPin, label: "Ankara · Çankaya" },
  { icon: Briefcase, label: "Borsa & Finans Piyasaları" },
  { icon: Calendar, label: "6+ Yıl Tecrübe" },
  { icon: Award, label: "Bağımsız İçerik Üreticisi" },
];

export default function About() {
  return (
    <section
      id="hakkinda"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div
              className="relative max-w-md mx-auto lg:mx-0"
              data-testid="about-image-wrapper"
            >
              <div className="photo-frame aspect-[4/5] shadow-2xl">
                <img
                  src={ABOUT_IMG}
                  alt="Derya Eliz Yıldız portre"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              {/* Floating accent card */}
              <div
                className="absolute -bottom-6 -right-6 md:-right-10 glass-card rounded-xl px-5 py-4 max-w-[230px]"
                data-testid="about-floating-card"
              >
                <div className="text-[10px] tracking-[0.28em] uppercase text-[#d4af37] mb-1">
                  Sertifika & Eğitim
                </div>
                <div className="text-sm text-white leading-snug font-light">
                  Sürekli piyasa eğitimi ve özveri ile geliştirilen analiz altyapısı.
                </div>
              </div>
              {/* Gold corner */}
              <div className="absolute -top-4 -left-4 w-14 h-14 border-t-2 border-l-2 border-[#d4af37] hidden md:block" />
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <span className="section-eyebrow" data-testid="about-eyebrow">
              Hakkında
            </span>
            <h2
              className="font-serif text-white text-[clamp(2rem,4.6vw,3.75rem)] leading-[1.08] mt-3"
              data-testid="about-title"
            >
              Piyasayı okur,
              <br />
              <span className="italic text-gold-gradient">fırsatları paylaşır.</span>
            </h2>

            <div className="gold-divider my-8" />

            <div className="space-y-5 text-[#cbd5e1] text-base md:text-lg font-light leading-relaxed">
              <p data-testid="about-paragraph-1">
                <span className="text-white font-medium">Derya Eliz Yıldız</span>,
                Ankara Çankaya doğumlu, yaklaşık 6 yıldır borsa ve finans
                piyasalarıyla ilgilenen, piyasa hareketlerini yakından takip eden
                ve yatırımcılara bilgilendirici içerikler sunan bir isimdir.
              </p>
              <p data-testid="about-paragraph-2">
                Amacı, borsa yatırımcılarının piyasaları daha bilinçli takip
                etmesine yardımcı olmak ve düzenli analizlerle fırsatları
                değerlendirmelerine katkı sağlamaktır.
              </p>
            </div>

            <div
              className="mt-10 grid grid-cols-2 gap-4"
              data-testid="about-meta-grid"
            >
              {META.map(({ icon: Icon, label }) => (
                <div
                  key={label}
                  className="flex items-center gap-3 glass-card rounded-lg px-4 py-3"
                  data-testid={`about-meta-${label.replace(/[^a-z0-9]/gi, "").toLowerCase()}`}
                >
                  <Icon size={18} className="text-[#d4af37] shrink-0" />
                  <span className="text-sm text-white/90 font-light">
                    {label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
